// extracted by mini-css-extract-plugin
export default {"faqHowMatchFindAgent":"faqHowMatchFindAgent_ilZbL","title":"title_bJFJg","imageContainer":"imageContainer_HKMOt","content":"content_pWaQW","button":"button_dZnxr"};